import { render, staticRenderFns } from "./Navigationlist.vue?vue&type=template&id=029c4a87&"
import script from "./navigationlist.js?vue&type=script&lang=js&"
export * from "./navigationlist.js?vue&type=script&lang=js&"
import style0 from "./Navigationlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports